import React from "react";  
  
const AdminIconButton = ({ onClick, active, disabled, badge, title, children }) => (  
  <button  
    onClick={onClick}  
    disabled={disabled}  
    title={title}  
    className={`relative flex items-center justify-center w-10 h-10 rounded-lg border transition-all ${  
      active  
        ? "bg-gold/10 border-gold/40 text-gold"  
        : "bg-black/40 border-gray-800 text-gray-400 hover:border-gold/40 hover:text-gold"  
    } disabled:opacity-40 disabled:cursor-not-allowed`}  
  >  
    {children}  
    {badge != null && (  
      <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 bg-gold text-black text-[10px] font-bold rounded-full flex items-center justify-center">  
        {badge}  
      </span>  
    )}  
  </button>  
);  
  
export default AdminIconButton;  